import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';



@Component({
    selector: 'grid-refresh',
    template: `
  <label class ="resetIcon"  (click)="refreshClicked()">
   <img   src="./assets/images/refresh_blue.svg" />
   </label>
    	`,
    styles: [
        `.mat-icon{
      margin-left:0px;
      vertical-align:middle;
	}

	.mat-icon:hover{
		cursor: pointer;
    }
    .resetIcon{
        cursor: pointer;

    }
    .filterText{
        position: absolute;
        top: 13px;
        font: normal normal normal 13px/16px Roboto;
        letter-spacing: 0px;
        color: #7B7C7C;
    }
    `
    ],
    standalone: false
})

export class GridRefreshComponent implements ICellRendererAngularComp {
	/*<mat-icon title="Refresh" class="mat-icon material-icons" role="img" aria-hidden="true"
	(click)="refreshClicked()">refresh
   </mat-icon> */
	@Input() cell: any;
	public params: any;
	constructor() { }
	refreshClicked(): void {
		this.params.api.setFilterModel(null);
		this.params.api.onFilterChanged();
		this.params.api.refreshCells();

		const refreshCallback = this.params.api.gridOptionsWrapper.gridOptions.context.componentParent;
		if (refreshCallback != null && refreshCallback.onRefresh != null && typeof (refreshCallback.onRefresh) == 'function') { // NOSONAR
			refreshCallback.onRefresh();
		}

	}
	agInit(params: any): void {
		this.params = params;

	}
	refresh(params: any): boolean {
		this.params = params;
		return true;
	}
}
